import request from '@/utils/request'

/**
 * 获取指定分组的配置（公开接口，登录即可访问）
 */
export function getConfigByGroup(group) {
  return request({
    url: `/system/config/group/${group}`,
    method: 'get'
  })
}

/**
 * 获取所有配置（管理员接口，支持按分组过滤）
 */
export function getConfigList(group) {
  return request({
    url: '/system/config/list',
    method: 'get',
    params: { group }
  })
}

/**
 * 获取所有分组名（管理员接口）
 */
export function getConfigGroups() {
  return request({
    url: '/system/config/groups',
    method: 'get'
  })
}

/**
 * 批量更新配置（管理员接口）
 */
export function batchUpdateConfig(data) {
  return request({
    url: '/system/config',
    method: 'put',
    data
  })
}
